import React, { useState } from 'react';

// Sample categories, subcategories, and descriptive subcategories data
const initialCategories = [
  'Electronics',
  'Home Appliances',
  'PersonalCare',
  'Fashion',
  'Grocery/Health',
];

const initialSubCategories = [
  { id: 1, name: 'Smart LED TV', category: 'Electronics' },
  { id: 2, name: 'Water Purifier', category: 'Home Appliances' },
  { id: 3, name: 'Health', category: 'Grocery/Health' },
  { id: 4, name: 'Coffee & Tea', category: 'Grocery/Health' },
  { id: 5, name: 'Kitchen Appliances', category: 'Home Appliances' },
  { id: 6, name: 'Hand & Palm', category: 'PersonalCare' },
];

const initialDescriptiveSubCategories = [
  { id: 1, name: 'RO', category: 'Home Appliances', subCategory: 'Water Purifier', status: 'Deactive' },
  { id: 2, name: 'Smart LED TV', category: 'Electronics', subCategory: 'Smart LED TV', status: 'Deactive' },
  { id: 3, name: 'RED ROSE', category: 'Grocery/Health', subCategory: 'Coffee & Tea', status: 'Deactive' },
  { id: 4, name: 'Energy Pendant', category: 'Grocery/Health', subCategory: 'Health', status: 'Deactive' },
  { id: 5, name: 'Gas Detectors', category: 'Home Appliances', subCategory: 'Kitchen Appliances', status: 'Deactive' },
  { id: 6, name: 'Hand Wash', category: 'PersonalCare', subCategory: 'Hand & Palm', status: 'Deactive' },
  { id: 7, name: 'Hand sanitizer', category: 'PersonalCare', subCategory: 'Hand & Palm', status: 'Deactive' },
];

const DescriptiveSubCategory = () => {
  const [categories] = useState(initialCategories);
  const [subCategories] = useState(initialSubCategories);
  const [descriptiveSubCategories, setDescriptiveSubCategories] = useState(initialDescriptiveSubCategories);
  const [categoryName, setCategoryName] = useState('');
  const [subCategoryName, setSubCategoryName] = useState('');
  const [descriptiveSubCategoryName, setDescriptiveSubCategoryName] = useState('');
  const [status, setStatus] = useState('Deactive');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  const handleCategoryChange = (e) => setCategoryName(e.target.value);
  const handleSubCategoryChange = (e) => setSubCategoryName(e.target.value);
  const handleDescriptiveSubCategoryChange = (e) => setDescriptiveSubCategoryName(e.target.value);

  const handleCancel = () => {
    setCategoryName('');
    setSubCategoryName('');
    setDescriptiveSubCategoryName('');
    setStatus('Deactive');
  };

  const handleCreateDescriptiveSubCategory = () => {
    if (descriptiveSubCategoryName.trim() && categoryName && subCategoryName) {
      const newDescriptiveSubCategory = {
        id: descriptiveSubCategories.length + 1,
        name: descriptiveSubCategoryName,
        category: categoryName,
        subCategory: subCategoryName,
        status: status,
      };
      setDescriptiveSubCategories([...descriptiveSubCategories, newDescriptiveSubCategory]);
      handleCancel();
    }
  };

  const handleDeleteDescriptiveSubCategory = (subCategoryId) => {
    const filteredDescriptiveSubCategories = descriptiveSubCategories.filter(
      (subCategory) => subCategory.id !== subCategoryId
    );
    setDescriptiveSubCategories(filteredDescriptiveSubCategories);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const currentItems = descriptiveSubCategories.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(descriptiveSubCategories.length / itemsPerPage);

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ textAlign: 'center', color: '#333', fontSize: '28px', marginBottom: '20px' }}>
        Create or Update Descriptive Sub Category
      </h1>

      {/* Form to Create or Update Descriptive Sub Category */}
      <div style={{ marginBottom: '20px' }}>
        <div style={{ marginBottom: '10px' }}>
          <label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '5px', display: 'block' }}>
            Select Category Name
          </label>
          <select
            value={categoryName}
            onChange={handleCategoryChange}
            style={{
              padding: '10px',
              fontSize: '14px',
              width: '100%',
              borderRadius: '5px',
              border: '1px solid #ccc',
              boxSizing: 'border-box',
            }}
          >
            <option value="">Select Category</option>
            {categories.map((category, index) => (
              <option key={index} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div style={{ marginBottom: '10px' }}>
          <label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '5px', display: 'block' }}>
            Select Sub Category Name
          </label>
          <select
            value={subCategoryName}
            onChange={handleSubCategoryChange}
            style={{
              padding: '10px',
              fontSize: '14px',
              width: '100%',
              borderRadius: '5px',
              border: '1px solid #ccc',
              boxSizing: 'border-box',
            }}
          >
            <option value="">Select Sub Category</option>
            {subCategories
              .filter((subCategory) => subCategory.category === categoryName)
              .map((subCategory, index) => (
                <option key={index} value={subCategory.name}>
                  {subCategory.name}
                </option>
              ))}
          </select>
        </div>

        <div style={{ marginBottom: '10px' }}>
          <label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '5px', display: 'block' }}>
            Enter Descriptive Sub Category Name
          </label>
          <input
            type="text"
            value={descriptiveSubCategoryName}
            onChange={handleDescriptiveSubCategoryChange}
            placeholder="Enter Descriptive Sub Category Name"
            style={{
              padding: '10px',
              fontSize: '14px',
              width: '100%',
              borderRadius: '5px',
              border: '1px solid #ccc',
              boxSizing: 'border-box',
            }}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '5px', display: 'block' }}>
            Status
          </label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{
              padding: '10px',
              fontSize: '14px',
              width: '100%',
              borderRadius: '5px',
              border: '1px solid #ccc',
              boxSizing: 'border-box',
            }}
          >
            <option value="Active">Active</option>
            <option value="Deactive">Deactive</option>
          </select>
        </div>

        <div>
          <button
            onClick={handleCreateDescriptiveSubCategory}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#28a745',
              color: 'white',
              borderRadius: '5px',
              border: 'none',
              marginRight: '10px',
              cursor: 'pointer',
            }}
          >
            Create Descriptive Sub Category
          </button>
          <button
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#dc3545',
              color: 'white',
              borderRadius: '5px',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
        </div>
      </div>

      {/* Descriptive Sub Category List */}
      <h2 style={{ marginTop: '40px', fontSize: '22px', textAlign: 'center' }}>
        Descriptive Sub Category List
      </h2>
      <table
        border="1"
        cellPadding="5"
        cellSpacing="0"
        style={{
          width: '100%',
          marginTop: '20px',
          borderCollapse: 'collapse',
          border: '1px solid #ddd',
        }}
      >
        <thead>
          <tr>
            <th style={{ textAlign: 'left', padding: '10px', backgroundColor: '#f4f4f4' }}>Descriptive Sub Category Name</th>
            <th style={{ textAlign: 'left', padding: '10px', backgroundColor: '#f4f4f4' }}>Category</th>
            <th style={{ textAlign: 'left', padding: '10px', backgroundColor: '#f4f4f4' }}>Sub Category</th>
            <th style={{ textAlign: 'left', padding: '10px', backgroundColor: '#f4f4f4' }}>Status</th>
            <th style={{ textAlign: 'center', padding: '10px', backgroundColor: '#f4f4f4' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((descriptiveSubCategory) => (
            <tr key={descriptiveSubCategory.id}>
              <td style={{ padding: '10px' }}>{descriptiveSubCategory.name}</td>
              <td style={{ padding: '10px' }}>{descriptiveSubCategory.category}</td>
              <td style={{ padding: '10px' }}>{descriptiveSubCategory.subCategory}</td>
              <td style={{ padding: '10px' }}>{descriptiveSubCategory.status}</td>
              <td style={{ textAlign: 'center', padding: '10px' }}>
                <button
                  onClick={() => handleDeleteDescriptiveSubCategory(descriptiveSubCategory.id)}
                  style={{
                    backgroundColor: '#dc3545',
                    color: 'white',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button
          disabled={currentPage === 1}
          onClick={() => paginate(currentPage - 1)}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            marginRight: '10px',
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '5px',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Previous
        </button>
        <button
          disabled={currentPage === totalPages}
          onClick={() => paginate(currentPage + 1)}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '5px',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default DescriptiveSubCategory;
